import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  errorNotification: 'Category could not be updated. Please try again.',
  heading: 'Edit Category',
  nameLabel: 'Name',
  nameRequiredError: 'Name is required.',
  successNotification: 'Category updated.',
})
